// extracted by mini-css-extract-plugin
export var blink = "_9i-2";
export var cursor = "_9i-1";
export var reactMarkdown = "_9i-3";
export var streamingText = "_9i-0";